import { createAction, ActionType, createReducer } from 'typesafe-actions';
import { CLEAR_USER } from './user';

export interface AccountServiceState {
  shopName: string;
  businessRegistrationNumber: string;
  shopContactName: string;
  shopContactEmail: string;
  shopContactPhoneNumber: string;
  evidenceExists: boolean;
  emailTax: string;
  emailCash: string;
  isTaxBill: number;
  isCashReceipt: number;
  onboardingExists: boolean;
  shopId: string;
  mid: string;
  applyUrl: string;
  applyUrlExpiresInSeconds: number;
  onboardingStatus: string;
  contractStatus: string;
  modifying: number | boolean;
  dashboardUrl: string;
  feeStatus: string;
  feePaidAt: string;
  credentialsSynced: boolean;
  credentialsSyncError: string;
  billingOnboardingExists: boolean;
  billingContractStatus: string;
  billingCredentialsSynced: boolean;
  autoPaymentEnabled: boolean;
  onboardingError: string;
  evidenceLoaded: boolean;
  onboardingLoaded: boolean;
  loaded: boolean;
}

const initialState: AccountServiceState = {
  shopName: '',
  businessRegistrationNumber: '',
  shopContactName: '',
  shopContactEmail: '',
  shopContactPhoneNumber: '',
  evidenceExists: false,
  emailTax: '',
  emailCash: '',
  isTaxBill: 0,
  isCashReceipt: 0,
  onboardingExists: false,
  shopId: '',
  mid: '',
  applyUrl: '',
  applyUrlExpiresInSeconds: 0,
  onboardingStatus: '',
  contractStatus: '',
  modifying: 0,
  dashboardUrl: '',
  feeStatus: '',
  feePaidAt: '',
  credentialsSynced: false,
  credentialsSyncError: '',
  billingOnboardingExists: false,
  billingContractStatus: '',
  billingCredentialsSynced: false,
  autoPaymentEnabled: false,
  onboardingError: '',
  evidenceLoaded: false,
  onboardingLoaded: false,
  loaded: false,
};

export const SET_ACCOUNT_SERVICE_INFO = 'AccountServiceReducer/SET_ACCOUNT_SERVICE_INFO';
export const CLEAR_ACCOUNT_SERVICE_INFO = 'AccountServiceReducer/CLEAR_ACCOUNT_SERVICE_INFO';

export const setAccountServiceInfo = createAction(SET_ACCOUNT_SERVICE_INFO)<Partial<AccountServiceState>>();
export const clearAccountServiceInfo = createAction(CLEAR_ACCOUNT_SERVICE_INFO)();

export const actions = { setAccountServiceInfo, clearAccountServiceInfo };
type AccountServiceReducerActions = ActionType<typeof actions> | { type: typeof CLEAR_USER };

const AccountServiceReducer = createReducer<AccountServiceState, AccountServiceReducerActions>(initialState, {
  [SET_ACCOUNT_SERVICE_INFO]: (state, action) => ({
    ...state,
    ...action.payload,
    loaded: true,
  }),
  [CLEAR_ACCOUNT_SERVICE_INFO]: () => initialState,
  [CLEAR_USER]: () => initialState,
});

export default AccountServiceReducer;
